import { render } from "./AlertsStock.vue?vue&type=template&id=71d48878"
import script from "./AlertsStock.vue?vue&type=script&lang=js"
export * from "./AlertsStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__